(function() {
  "use strict";

  angular
    .module("app")
    .factory("CommunitiesService", ["$http", "$q", CommunitiesService]);

  function CommunitiesService($http, $q) {
    var _communities = [];
    var service = {
      getCommunityData: getCommunityData
    };

    // Prevents unnecessary API calls
    var communitiesAreLoaded = false;

    function getCommunityData(domainId, yearId, includeOtherIndicators) {
      var deferred = $q.defer();

      $http({
        method: "GET",
        url:
          "api/RiskRankingData/GetDomainLocation?id=" +
          domainId +
          "&timeFrame=" +
          yearId +
          "&includeOtherIndicators=" +
          (includeOtherIndicators ? "true" : "false"),
        cache: true // this data rarely updates, no need for an instant re-request
      })
        .success(function(data) {
          processCommunityData(data);
        })
        .error(function(error) {
          deferred.reject();
        });

      function processCommunityData(data) {
        deferred.resolve(data);
      }

      return deferred.promise;
    }

    return service;
  }
})();
